import { render, staticRenderFns } from "./NvbbDrinkProduct.vue?vue&type=template&id=e6a1cf0e&scoped=true&"
import script from "./NvbbDrinkProduct.vue?vue&type=script&lang=js&"
export * from "./NvbbDrinkProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a1cf0e",
  null
  
)

export default component.exports